import { Injectable } from "@angular/core";

import { sql, SQLConfig } from "@codemirror/lang-sql";
import { LanguageDescription, LanguageSupport } from "@codemirror/language";

import { SqlLanguageSpec } from "../models";
import { SqlEditorLanguageConfigService } from "./sql-editor-language-config.service";


@Injectable()
export class SqlEditorLanguageService {

    constructor(private configurationService: SqlEditorLanguageConfigService) {
    }

    public getLanguageDescription(config?: SqlLanguageSpec): LanguageDescription {
        const language: LanguageSupport = this.getLanguageExtension(config);

        return LanguageDescription.of({ name: language.language.name, support: language })
    }

    public getLanguageExtension(config?: SqlLanguageSpec): LanguageSupport {
        if (!config) return sql();

        const configuration: SQLConfig = this.configurationService.getSqlConfiguration(config);

        return sql(configuration);
    }
}